var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "dashboardRef", staticClass: "data-views" }, [
    _c("div", { staticClass: "data-views-div" }, [
      _c("div", { staticClass: "data-views-header" }, [
        _c("div", { staticClass: "data-views-title" }, [
          _vm._v("共青团广西区委网络舆情监控")
        ]),
        _c("div", { staticClass: "header-date" }, [
          _c("div", { staticClass: "header-date-time" }, [
            _vm._v(" " + _vm._s(_vm.currentTime) + " ")
          ]),
          _c("div", [
            _c("div", [_vm._v(_vm._s(_vm.currentDayOfWeek))]),
            _c("div", [_vm._v(_vm._s(_vm.currentDate))])
          ])
        ])
      ]),
      _c("div", { staticClass: "data-views-main-content" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            [
              _c("Title", [_vm._v(" 今日舆情")]),
              _c("div", { staticClass: "drawing-board" }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/top-left.png"),
                    alt: ""
                  }
                }),
                _c("div", { staticClass: "event" }, [
                  _c("p", [_vm._v("今日舆情事件")]),
                  _c("p", { staticStyle: { "margin-top": "10px" } }, [
                    _c("span", [
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.toDayData.length) + " ")
                      ]),
                      _vm._v("件 ")
                    ])
                  ])
                ])
              ]),
              _c(
                "div",
                { staticClass: "list", staticStyle: { height: "300px" } },
                [
                  _vm.toDayData.length > 0
                    ? _vm._l(_vm.toDayData, function(item, index) {
                        var _obj
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "table-list",
                            class:
                              ((_obj = {}),
                              (_obj["table-list-" + index] = index < 3),
                              _obj)
                          },
                          [
                            index === 0
                              ? _c("span", { staticClass: "list-date" }, [
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm._f("day")(item.CreationTime)) +
                                        " "
                                    )
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm._f("month")(item.CreationTime))
                                    )
                                  ])
                                ])
                              : _c("span", { staticClass: "list-date" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("monthDay")(item.CreationTime)
                                      )
                                    )
                                  ])
                                ]),
                            _c("span", { staticClass: "list-content" }, [
                              _vm._v(_vm._s(item.ContentSummary))
                            ])
                          ]
                        )
                      })
                    : _c("div", { staticClass: "empty-state" }, [
                        _vm._m(0),
                        _c("div", { staticClass: "empty-content" }, [
                          _c("div", { staticClass: "empty-icon-container" }, [
                            _c("div", { staticClass: "pulse-ring" }),
                            _c("div", { staticClass: "pulse-ring delay-1" }),
                            _c("div", { staticClass: "pulse-ring delay-2" }),
                            _c("div", { staticClass: "empty-icon" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "80",
                                    height: "80",
                                    viewBox: "0 0 80 80",
                                    fill: "none"
                                  }
                                },
                                [
                                  _c("circle", {
                                    staticClass: "rotate-slow",
                                    attrs: {
                                      cx: "40",
                                      cy: "40",
                                      r: "35",
                                      stroke: "rgba(33, 150, 243, 0.3)",
                                      "stroke-width": "2",
                                      "stroke-dasharray": "8 4"
                                    }
                                  }),
                                  _c("circle", {
                                    staticClass: "rotate-fast",
                                    attrs: {
                                      cx: "40",
                                      cy: "40",
                                      r: "28",
                                      stroke: "rgba(0, 188, 212, 0.2)",
                                      "stroke-width": "1.5",
                                      "stroke-dasharray": "6 3"
                                    }
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "30",
                                      y: "25",
                                      width: "20",
                                      height: "30",
                                      rx: "2",
                                      stroke: "rgba(33, 150, 243, 0.8)",
                                      "stroke-width": "2",
                                      fill: "none"
                                    }
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "32",
                                      y: "30",
                                      width: "16",
                                      height: "2",
                                      fill: "rgba(33, 150, 243, 0.6)"
                                    }
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "32",
                                      y: "35",
                                      width: "12",
                                      height: "2",
                                      fill: "rgba(33, 150, 243, 0.5)"
                                    }
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "32",
                                      y: "40",
                                      width: "14",
                                      height: "2",
                                      fill: "rgba(33, 150, 243, 0.4)"
                                    }
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "32",
                                      y: "45",
                                      width: "10",
                                      height: "2",
                                      fill: "rgba(33, 150, 243, 0.3)"
                                    }
                                  }),
                                  _c("line", {
                                    staticClass: "scan-line",
                                    attrs: {
                                      x1: "25",
                                      y1: "40",
                                      x2: "55",
                                      y2: "40",
                                      stroke: "rgba(0, 255, 255, 0.6)",
                                      "stroke-width": "1"
                                    }
                                  })
                                ]
                              )
                            ])
                          ]),
                          _vm._m(1)
                        ])
                      ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ch2-list", staticStyle: { "margin-top": "16px" } },
            [
              _c("Title", [_vm._v(" 热门关键词")]),
              _c("Wordcloud", { attrs: { inputText: _vm.allData.text } })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "center" }, [
          _c(
            "div",
            { staticClass: "top" },
            [
              _c("Pseudo3DMap", {
                staticStyle: { width: "100%", height: "700px" },
                attrs: { cityDic: _vm.allData.cityDic }
              }),
              _c("div", { staticClass: "event" }, [
                _c("div", { staticClass: "event-title" }, [_vm._v("总舆情数")]),
                _c(
                  "div",
                  { staticClass: "event-count" },
                  [
                    _c("DigitalFlipper", {
                      staticClass: "event-ul",
                      attrs: { total: _vm.negativeTotalCount.toString() }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "event-type" }, [
                  _c("div", { staticClass: "event-detail" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/event.png"),
                        alt: ""
                      }
                    }),
                    _c("div", [
                      _c("div", { staticClass: "event-name" }, [
                        _vm._v("待处置事件")
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "event-number" }, [
                          _vm._v(" " + _vm._s(_vm.allData.dczCount) + " ")
                        ]),
                        _vm._v("件 ")
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "event-detail" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/evented.png"),
                        alt: ""
                      }
                    }),
                    _c("div", [
                      _c("div", { staticClass: "event-name" }, [
                        _vm._v("已处置事件")
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "event-number" }, [
                          _vm._v(" " + _vm._s(_vm.allData.yczCount) + " ")
                        ]),
                        _vm._v(" 件 ")
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { padding: "0 16px" } },
            [
              _c("Title", [_vm._v(" 舆情趋势统计 ")]),
              _c("TrendChart", {
                ref: "trendChartRef",
                attrs: { dateRange: _vm.dateValues }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            [
              _c("Title", [_vm._v(" 事件分类排行")]),
              _c("div", { staticStyle: { "margin-top": "16px" } }, [
                _c(
                  "div",
                  { staticClass: "right-drawing-board" },
                  _vm._l(_vm.rankData, function(item, index) {
                    return _c("div", { key: index, staticClass: "rank" }, [
                      _c("span", { staticClass: "rank-text" }, [
                        _c("i", [_vm._v("Top ")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "rank-number" }, [
                          _vm._v(" " + _vm._s(index + 1) + " ")
                        ])
                      ]),
                      _c("span", { staticClass: "rank-name" }, [
                        _vm._v(" " + _vm._s(item.name) + " ")
                      ]),
                      _c("span", {
                        staticClass: "rank-rectangle",
                        style: { "--rank": item.percentage + "%" }
                      }),
                      _c("span", { staticClass: "rank-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.value) +
                            " (" +
                            _vm._s(item.percentageText) +
                            ") "
                        )
                      ]),
                      _c("img", {
                        attrs: {
                          src: require("../../assets/images/rank.png"),
                          alt: ""
                        }
                      })
                    ])
                  }),
                  0
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ch2-list", staticStyle: { "margin-top": "16px" } },
            [
              _c("Title", [_vm._v(" 网络舆情")]),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px" } },
                [
                  _vm.negativeData.length
                    ? _c("ScrollBoard", {
                        attrs: { data: _vm.negativeData, height: 600 },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var record = ref.record
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "alert-item",
                                      class: {
                                        pending: record.DealState === 0,
                                        processing: record.DealState === 1,
                                        completed: record.DealState === 2
                                      }
                                    },
                                    [
                                      _c(
                                        "a-popover",
                                        { attrs: { title: "内容摘要" } },
                                        [
                                          _c("template", { slot: "content" }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "1.2rem",
                                                  width: "500px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(record.ContentSummary)
                                                )
                                              ]
                                            )
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text-ellipsis" },
                                            [
                                              _vm._v(
                                                _vm._s(record.ContentSummary)
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      ),
                                      _c("span", { staticClass: "date" }, [
                                        record.DealState === 0
                                          ? _c(
                                              "span",
                                              { staticClass: "table-state" },
                                              [_vm._v("未处置")]
                                            )
                                          : record.DealState === 1
                                          ? _c(
                                              "span",
                                              { staticClass: "table-state" },
                                              [_vm._v("处置中")]
                                            )
                                          : record.DealState === 2
                                          ? _c(
                                              "span",
                                              { staticClass: "table-state" },
                                              [_vm._v("已处置")]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "table-state" },
                                              [_vm._v("--")]
                                            )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2411359482
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-bg-pattern" }, [
      _c("div", { staticClass: "grid-line" }),
      _c("div", { staticClass: "grid-line" }),
      _c("div", { staticClass: "grid-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-text-container" }, [
      _c("div", { staticClass: "empty-subtitle" }, [_vm._v("暂无今日舆情数据")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }